import BulkUpdaterEditor from './BulkUpdaterEditor';

export default BulkUpdaterEditor;
